import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

import { ApplicationImage, Dimensions, ApplicationView } from "../../models";
import { randomNumber } from "../../util";

@Component({
	selector: "sdp-application-image",
	templateUrl: "./application-image.component.html",
})

export class ApplicationImageComponent implements OnChanges {
	private dimensions: Dimensions = { width: 0, height: 0 };
	protected imageColor: string;

	private _size: ApplicationView.ImageSize = "full";
	// determine if the image is rendered exact or half the size of the original
	private readonly fullSize = 1;
	private readonly halfSize = 2;

	private readonly colors = ["#4286f4", "#1f9e38", "#8c1721", "#7f2cb2", "#c18f19", "#c41799"];

	@Input()
	public applicationImage!: ApplicationImage;

	public get size() {
		return this._size;
	}

	@Input()
	public set size(newSize: ApplicationView.ImageSize) {
		this._size = newSize;
		this.updateDimensionBySize(this._size);
	}

	public constructor() {
		this.imageColor = this.colors[randomNumber(6)];
	}

	public getDisplayValue() {
		return this.applicationImage.name.charAt(0).toUpperCase() || "";
	}

	public hasImage() {
		return !!this.applicationImage.imageBase64;
	}

	public isSmall() {
		return this.size === "small";
	}

	public ngOnChanges(changes: SimpleChanges) {
		if (!!changes.applicationImage) {
			this.applicationImage = changes.applicationImage.currentValue;
			this.updateDimensionBySize(this._size);
		}
	}

	private updateDimensions(size: number) {
		if (!!this.applicationImage.imageBase64) {
			const img = document.createElement("img");
			img.src = this.applicationImage.imageBase64;
			img.onload = () => {
				this.dimensions.width = img.width / size;
				this.dimensions.height = img.height / size;
			};
		}
	}

	private updateDimensionBySize(size: ApplicationView.ImageSize) {
		if (size === "small") {
			this.updateDimensions(this.halfSize);
		} else {
			this.updateDimensions(this.fullSize);
		}
	}
}
